export default __webpack_public_path__ + "static/media/magician.08a6fafc.png";